'use client'

import { m, useInView, useSpring, useTransform } from 'framer-motion'
import { useEffect, useRef } from 'react'

export default function AnimatedCounter({
  value,
  label,
  prefix = '',
  suffix = '',
  precision = 0,
  className = 'text-center',
}: {
  value: number
  label?: string
  prefix?: string
  suffix?: string
  precision?: number
  className?: string
}) {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, margin: '0px 0px 100px 0px' })

  // Spring physics for smooth counting
  const spring = useSpring(0, { mass: 0.8, stiffness: 75, damping: 15 })
  const display = useTransform(spring, (current) => {
    const n = Number(current)
    const text = n.toLocaleString(undefined, {
      minimumFractionDigits: precision,
      maximumFractionDigits: precision,
    })
    return prefix + text + suffix
  })

  useEffect(() => {
    if (isInView) {
      spring.set(value)
    }
  }, [isInView, value, spring])

  return (
    <div ref={ref} className={className}>
      <m.p className="mb-2 bg-gradient-to-b from-white to-gray-400 bg-clip-text text-4xl font-bold text-transparent md:text-5xl">
        {display}
      </m.p>
      {label ? <p className="text-sm tracking-widest text-gray-500 uppercase">{label}</p> : null}
    </div>
  )
}
